import React from "react";
import logo from "./Logo.png";

const Heading = () => {
  return (
    <header className="App-header">
      <img className="App-logo" src={logo} alt="Logo" />
      CYF Hotel
    </header>
  );
};

export default Heading;
